import { Button, InfoModal } from "@newsela/angelou";
import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";

import useUserTermsOfServicePost from "@/view/utils/useUserTermsOfServicePost";
import { modalCss, footerCss } from "./FormativeTOSModal.style";

interface FormativeTOSModalProps {
  currentTOSVersion: number;
  data: {
    url: string;
    payload: string;
  };
  formativeTOSText: string;
  onClose: () => void;
  setShouldDisplayFormativeTOS: (shouldDisplayFormativeTOS: boolean) => void;
  userId: string;
}

const FORMATIVE_TOS_SLUG = "formative-tos";

const ButtonWithTrackEvent = withTrackEvent(
  Button,
) as React.ForwardRefExoticComponent<
  React.ComponentProps<typeof Button> & React.RefAttributes<HTMLButtonElement>
>;

const FormativeTOSModal = (props: FormativeTOSModalProps) => {
  const [updateTermsOfServiceAgreement] = useUserTermsOfServicePost();

  const handleAcceptTerms = () => {
    updateTermsOfServiceAgreement({
      userId: props.userId,
      slug: FORMATIVE_TOS_SLUG,
      version: props.currentTOSVersion,
    });
    props.onClose();
    props.setShouldDisplayFormativeTOS(false);
  };

  const cancelEventProperties = {
    objectType: objectTypes.content,
    actionPrefix: actionPrefixes.initiate,
    actionName: actionNames.navigate,
    streamProperties: {
      description: "Cancel Formative TOS",
    },
  };

  const acceptEventProperties = {
    objectType: objectTypes.content,
    actionPrefix: actionPrefixes.initiate,
    actionName: actionNames.navigate,
    streamProperties: {
      description: "Accept Formative TOS",
    },
  };

  return (
    <InfoModal
      __cssFor={{
        root: modalCss,
        footer: footerCss,
      }}
      closeButtonProps={{
        dataProps: { "data-qa-selector": "close-formative-tos" },
      }}
      title="Formative’s Terms of Service"
      eyebrow={"Accept Formative's Terms of Service to continue"}
      footer={
        <>
          <ButtonWithTrackEvent
            dataProps={{ "data-qa-selector": "cancel-formative-tos" }}
            flavor={Button.flavors.secondary}
            onClick={props.onClose}
            {...cancelEventProperties}
          >
            Cancel
          </ButtonWithTrackEvent>
          <form method="post" action={props.data.url} target="_blank">
            <input name="id_token" type="hidden" value={props.data.payload} />
            <ButtonWithTrackEvent
              dataProps={{ "data-qa-selector": "accept-formative-tos" }}
              type="submit"
              flavor={Button.flavors.primary}
              onClick={handleAcceptTerms}
              {...acceptEventProperties}
            >
              Accept & continue
            </ButtonWithTrackEvent>
          </form>
        </>
      }
      {...props}
    >
      <div
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: props.formativeTOSText }}
      />
    </InfoModal>
  );
};

export default FormativeTOSModal;
